'use client'

/**
 * Global error fallback — renders outside all layouts, so it must provide its own <html>/<body>.
 * This only triggers when the root layout itself throws; normal page errors are caught by (site)/error.tsx.
 */
export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="hu">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#020b26',
          color: '#f1f1f1',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          textAlign: 'center',
          padding: '2rem',
        }}
      >
        <div>
          <h1 style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>Valami hiba történt!</h1>
          <p style={{ fontSize: '1.1rem', opacity: 0.7, marginBottom: '1.5rem' }}>
            Kérjük, próbáld újra később.
          </p>
          <button
            onClick={() => reset()}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#FE4C04',
              color: '#fff',
              border: 'none',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            Újrapróbálás
          </button>
        </div>
      </body>
    </html>
  )
}
